module.exports = __webpack_public_path__ + "static/media/premiere.57765d67.svg";